import { render, staticRenderFns } from "./DemoGuideBadge.vue?vue&type=template&id=40608ad1&scoped=true&"
import script from "./DemoGuideBadge.vue?vue&type=script&lang=js&"
export * from "./DemoGuideBadge.vue?vue&type=script&lang=js&"
import style0 from "./DemoGuideBadge.vue?vue&type=style&index=0&id=40608ad1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40608ad1",
  null
  
)

export default component.exports